import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Input } from '@angular/core';

@Component({
	standalone: true,
	selector: 'loader-overlay',
	templateUrl: './loader-overlay.component.html',
	imports: [ CommonModule, FormsModule ]
})
export class LoaderOverlayComponent implements OnInit {
	
	@Input() theme: any | undefined;
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		
	}

}